import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

function PreferencesSectionItem(props) {
  const { onSave, onChange, onClose, onReset, name, prefix, fullName, children, ...rest } = props;
  // eslint-disable-next-line no-shadow
  const handleChange = (name, value) => {
    onChange(fullName || `${prefix}.${name}`, value);
  };
  const handleSave = (...restParams) => onSave(name, ...restParams);
  const handleReset = (...restParams) => onReset(name, ...restParams);
  const handleClose = (...restParams) => onClose(name, ...restParams);
  return React.cloneElement(children, {
    ...rest,
    onChange: handleChange,
    onSave: handleSave,
    onReset: handleReset,
    onClose: handleClose,
  });
}

PreferencesSectionItem.propTypes = {
  onSave: PropTypes.func,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  onReset: PropTypes.func,
  name: PropTypes.string,
  prefix: PropTypes.string,
  fullName: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
};

PreferencesSectionItem.defaultProps = {
  onChange: noop,
  onSave: noop,
  onClose: noop,
  onReset: noop,
};

export default PreferencesSectionItem;
